import type { ClientFile } from "@repo/shared/types";
import { Phone, StickyNote, Users } from "lucide-react";
import { getFileTypeIcon } from "@/lib/utils";

/** The four things the Notes & files tab lists (QL-125). */
export type ClientRecordKind = "note" | "call" | "meeting" | "file";
/** The kinds with an inline editor; files only upload, open and delete. */
export type EditableRecordKind = Exclude<ClientRecordKind, "file">;

// One icon per kind so the Type column here and the Activity tab's Type column
// read the same. Files use their file-type glyph (image / audio / document).
export function recordKindIcon(kind: ClientRecordKind, file?: ClientFile) {
  if (kind === "meeting") return <Users className="h-4 w-4" />;
  if (kind === "call") return <Phone className="h-4 w-4" />;
  if (kind === "file") {
    const Icon = getFileTypeIcon(file?.fileType ?? "document");
    return <Icon className="h-4 w-4" />;
  }
  return <StickyNote className="h-4 w-4" />;
}
